import { cardiacBeatTime, cardiacCycles, createContour, respiratoryPhase } from './pulseModel.js';

// Illustrative lead II sinus beat, in mV and seconds relative to the R peak.
// PR: 160 ms; QRS: 90 ms; QT: 380 ms. These do not stretch with each RR interval.
// Normal morphology reference: https://pmc.ncbi.nlm.nih.gov/articles/PMC5137383/
const qrs = createContour([
  [-0.035, 0],
  [-0.024, -0.065],
  [-0.016, 0],
  [0, 1],
  [0.017, 0],
  [0.032, -0.18],
  [0.055, 0],
]);

// Compact support gives exact wave boundaries and isoelectric PR/ST segments.
// Both ends have zero slope, avoiding jumps when a wave meets the baseline.
const roundedWave = (seconds, onset, peak, end, amplitude) => {
  if (seconds <= onset || seconds >= end) return 0;
  const phase =
    seconds <= peak ? (seconds - onset) / (peak - onset) : (end - seconds) / (end - peak);
  return (amplitude * (1 - Math.cos(Math.PI * phase))) / 2;
};

export const ecgBeat = (seconds) =>
  roundedWave(seconds, -0.195, -0.15, -0.105, 0.12) +
  qrs(seconds) +
  roundedWave(seconds, 0.145, 0.265, 0.345, 0.28);

export const ecgBaseline = (seconds) => 0.006 * Math.sin(respiratoryPhase(seconds));

export const ecgVoltage = (seconds) => {
  // The nearest R peak includes the upcoming beat's P wave before phase zero.
  // The switch between adjacent beats falls within their shared resting baseline.
  const rPeakTime = cardiacBeatTime(Math.round(cardiacCycles(seconds)));
  return ecgBeat(seconds - rPeakTime) + ecgBaseline(seconds);
};
